import type { BarcodeScannerFormat, BarcodeScannerFormatKind } from '../types'
import { toFormatKind } from './to-format-kind'

export const filterByFormatKind = (
  formats: BarcodeScannerFormat[],
  formatKind: BarcodeScannerFormatKind
): BarcodeScannerFormat[] => formats.filter((format) => toFormatKind(format) === formatKind)
